"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Twitter = function Twitter() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M271,594h-384V210h384V594z M225,313.7c-10.4,4.7-21.7,7.8-33.8,9.5c12.7-7.4,21.3-18.3,26-32.7  c-12.1,7.1-24.6,11.8-37.4,14.2c-11.4-12.3-25.6-18.4-42.7-18.4c-16.2,0-30,5.7-41.5,17.2S78.4,328.8,78.4,345  c0,5.4,0.5,9.9,1.4,13.4c-24-1.3-46.5-7.4-67.6-18.2S-26.7,315-41.4,297c-5.4,9.3-8.1,19.2-8.1,29.6c0,21.2,8.5,37.5,25.4,48.9  c-8.8-0.2-18.1-2.6-27.9-7.3v0.6c0,14,4.7,26.4,14,37.3s20.8,17.6,34.4,20.2c-5.4,1.5-10.1,2.2-14.2,2.2c-2.4,0-6.1-0.4-10.9-1.1  c3.9,11.7,10.8,21.4,20.8,29s21.3,11.5,33.9,11.7C4.3,485-20,493.3-47,493.3c-4.8,0-9.5-0.3-14-0.8c27.6,17.5,57.5,26.3,89.9,26.3  c20.9,0,40.4-3.3,58.7-9.9s33.9-15.5,46.9-26.5s24.3-23.8,33.7-38.3s16.4-29.5,20.9-45.2s6.8-31.4,6.8-47.1c0-3.4-0.1-5.9-0.3-7.5  C207.4,335.8,217.2,325.7,225,313.7z"
  }));
};

Twitter.displayName = 'Twitter';
var _default = Twitter;
exports["default"] = _default;
Twitter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Twitter"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Twitter.js"] = {
    name: "Twitter",
    docgenInfo: Twitter.__docgenInfo,
    path: "src/Twitter.js"
  };
}